import { LegalDisclaimer, OfferMedia } from '~/common/models';
import styles from './index.module.scss';
import React from 'react';
import { DeviceType } from '../offer-listing/offerDeviceType';

interface LegalDisclaimerProps {
  disclaimer?: OfferMedia;
  deviceType?: DeviceType;
}
export const LegalDisclaimerContent = React.memo<LegalDisclaimerProps>(
  ({ disclaimer, deviceType }) => {
    const displayText =
      deviceType !== 'mobile'
        ? disclaimer?.disclaimer
        : disclaimer?.mobileDisclaimer;

    return disclaimer?.disclaimerIsVisible ? (
      <div
        className={styles.offerdisclaimer}
        style={{
          color: disclaimer?.disclaimerColor ?? '#fff',
          textAlign: disclaimer?.disclaimerAlignment ?? 'left',
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: displayText ?? '' }} />
      </div>
    ) : (
      <></>
    );
  }
);
